import * as React from 'react';
import { useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import Shubox from 'shubox';
import { UserContext } from '../../../context/UserContext';
import client from '../../../lib/client';
import { setAvatarMutation } from '../../../queries/user';
import {
  SetAvatarMutation,
  SetAvatarMutationVariables
} from '../../../queries/__generated__/SetAvatarMutation';
import { Card, CardSegment } from '../../ui';
import { variables } from '../../utils';

const UserAvatar: React.FC = () => {
  const { user, reloadUser } = useContext(UserContext);

  useEffect(() => {
    new Shubox('#avatar', {
      key: process.env.REACT_APP_SHUBOX_KEY,
      transformName: 'avatar',
      success: (file: any) => {
        client
          .mutate<SetAvatarMutation, SetAvatarMutationVariables>({
            mutation: setAvatarMutation,
            variables: {
              input: {
                userId: user.id,
                avatarUrl: file.s3url
              }
            }
          })
          .then(
            () => {
              reloadUser();
              toast(`Avatar updated!`, { type: 'success' });
            },
            reason => toast(reason, { type: 'error' })
          );
      },
      error: (message: string) => {
        toast(`Error uploading avatar: ${message}`, { type: 'error' });
      },
      maxFiles: 1,
      maxFileSize: 500,
      clickable: ['.launch-dz']
    } as any);
  }, []);

  return (
    <Card className="mb2">
      <CardSegment className="pa4">
        <h3 className="f5 fw6 mt0 mb3">Avatar</h3>
        <div className="launch-dz flex">
          <div
            className="bg-near-white br-100 overflow-hidden"
            style={{
              height: 64,
              width: 64,
              background: `${variables.nearWhite} url(${user.avatarUrl}) center center`,
              backgroundSize: 'cover'
            }}
          >
            <div id="avatar" />
          </div>
          <button className="launch-dz f7 blue hover-navy ml2">Edit</button>
        </div>
      </CardSegment>
    </Card>
  );
};

export default UserAvatar;
